import Container from "../components/Container";
import Logo from "../images/logo.png"
import {Button} from "antd"
import AuthContext from "../utilis/contexts/AuthContext";
import {useContext} from "react";
import LocalStorage from "../utilis/tools/LocalStorage";

const Bill = () => {
    const authContext=useContext(AuthContext)
    const branchInfo=authContext.currentBranchInfo.name.length? authContext.currentBranchInfo:LocalStorage.getBranchInfo();
    console.log(branchInfo)
    return <Container fluid>
        <div className="mt-3 bg-white text-xs text-black font-bold  w-full shadow min-h-[400px] p-3 rounded">
            <div className="w-full flex justify-center"><small className="text-red-600 mx-auto">دریافت غیرحضوری خدمات
                22گانه با ورود به سایت شرکت به آدرس www.abfa-mazandaran.ir ، دریافت اپلیکیشن ومراجعه به پیشخوان دولت
                امکان پذیر می باشد</small></div>
            <Container>
                <div className="w-full flex  mt-1 justify-center items-center">
                    <div className="w-full  text-black  md:w-6/12 lg:w-2/12">شهر: {branchInfo.city}</div>
                    <div className="w-full  text-black  md:w-6/12 ">آدرس امور: {branchInfo.co_address}

                    </div>
                    <div className="w-full  text-black  md:w-6/12 lg:w-2/12 ">تلفن امور: {branchInfo.co_tel}</div>
                    <div className="w-full  text-black  md:w-6/12 lg:w-2/12">تلفن امداد: ۱۲۲</div>
                </div>
                <div className="w-full flex justify-start items-center"><img className="w-[60px]    ml-2 h-auto"
                                                                             src={Logo} alt=""/><strong
                    className="text-xs">شرکت آب و فاضلاب استان مازندران</strong></div>
            </Container>
            <div className="w-full flex flex-wrap">
                <div className="w-8/12 p-1">
                    <div className="w-full">
                        <div className="w-full grid grid-cols-3 p-2 gap-3 border border-black rounded ">
                            <span>مشترک گرامی: {branchInfo.name}</span>
                            <span>شماره پرونده: {authContext.currentFileNumber}</span>
                            <span>کد مامور: {branchInfo.agent_code}</span>
                            <span>کد جغرافیایی: {branchInfo.geographical_code}</span>
                            <span>تاریخ صدور: {branchInfo.bill_exportation_date}</span>
                            <span>سریال: {branchInfo.bill_serial}</span>
                            <span >آدرس : {branchInfo.address}</span>
                            <span/>
                            <span>کدپستی: {branchInfo.postal_code}</span>
                        </div>
                        <div className="w-full flex justify-start flex-wrap items-start">
                            <div className=" w-full mt-1 p-1 md:w-5/12">
                                <div className="table-responsive w-full">
                                    <table className="table table-bordered">
                                        <thead className="bg-gray-200">
                                        <tr>
                                            <th  style={{
                                                width:"40%"
                                            }}  className="no-border  "><strong>کد و نوع تعرفه
                                                قرارداد</strong>
                                            </th>
                                            <th className="no-border  small1"><strong>{branchInfo.account_type}</strong></th>
                                        </tr>
                                        </thead>
                                        <tbody className="table-hover">
                                        <tr>
                                            <td className="no-border  small1 "><strong>نوع فروش</strong>
                                            </td>
                                            <td className="no-border  small1 "><strong>{branchInfo.selling_type==="[]"?"":branchInfo.selling_type}</strong></td>
                                        </tr>
                                        <tr>
                                            <td className="no-border   small1"><strong>تعداد واحد
                                                اصلی</strong></td>
                                            <td className="no-border   small1"><strong>{branchInfo.units_number}</strong></td>
                                        </tr>
                                        <tr>
                                            <td className="no-border   small1"><strong>تعداد واحد
                                                فرعی</strong></td>
                                            <td className="no-border   small1"><strong>{branchInfo.extra_unit}</strong></td>
                                        </tr>
                                        <tr>
                                            <td className="no-border   small1"><strong>ظرفیت
                                                قراردادی</strong>
                                            </td>
                                            <td className="no-border   small1"><strong>{branchInfo.contract_capacity}</strong></td>
                                        </tr>
                                        <tr>
                                            <td className="no-border   small1"><strong>وضعیت
                                                کنتور</strong>
                                            </td>
                                            <td className="no-border   small1"><strong>{branchInfo.meter_status==="[]"?"":branchInfo.meter_status}</strong></td>
                                        </tr>
                                        <tr>
                                            <td className="no-border   small1"><strong>شماره بدنه
                                                کنتور</strong></td>
                                            <td className="no-border   small1"><strong>{branchInfo.meter_body_number}</strong></td>
                                        </tr>
                                        <tr>
                                            <td className="no-border   small1"><strong>تاریخ نصب</strong>
                                            </td>
                                            <td className="no-border   small1"><strong>{branchInfo.installation_date}</strong></td>
                                        </tr>
                                        <tr>
                                            <td className="no-border   small1"><strong>قطر انشعاب
                                                آب</strong>
                                            </td>
                                            <td className="no-border   small1"><strong>{branchInfo.branch_diameter}</strong></td>
                                        </tr>
                                        <tr>
                                            <td className="no-border   small1"><strong>قطر سیفون</strong>
                                            </td>
                                            <td className="no-border   small1"><strong>{branchInfo.waste_water_diameter==="[]"?"":branchInfo.waste_water_diameter}</strong></td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className=" w-full mt-1 md:w-4/12 p-1">
                                <div className="table-responsive">
                                    <table className="table table-bordered">
                                        <thead className="bg-gray-200">
                                        <tr>
                                            <th className="  small1"></th>
                                            <th className="  "><strong>قرائت قبلی</strong></th>
                                            <th className="  "><strong>قرائت فعلی</strong></th>
                                        </tr>
                                        </thead>
                                        <tbody className="table-hover">
                                        <tr>
                                            <td className="  small1"><strong>تاریخ</strong></td>
                                            <td className="  small1"><strong>{branchInfo.previous_date}</strong></td>
                                            <td className="  small1"><strong>{branchInfo.current_date}</strong></td>
                                        </tr>
                                        <tr>
                                            <td className="  small1"><strong>شماره کنتور</strong></td>
                                            <td className="  small1"><strong>{branchInfo.previous_number}</strong></td>
                                            <td className="  small1"><strong>{branchInfo.current_number}</strong></td>

                                        </tr>
                                        <tr>
                                            <td className="  small1"><strong>نحوه قرائت</strong></td>
                                            <td className="  small1"><strong>{branchInfo.reading_type}</strong></td>
                                            <td className="  small1"><strong></strong></td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-bordered">
                                        <thead className="bg-gray-200">
                                        <tr>
                                            <th colSpan={2} className="  "><strong className="">مصرف</strong>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody className="table-hover">
                                        <tr>
                                            <td style={{width:"50%"}} className="no-border   small1"><strong>طول دوره
                                                (روز)</strong></td>
                                            <td className="no-border   small1"><strong>{branchInfo.total_day}</strong></td>
                                        </tr>
                                        <tr>
                                            <td className="no-border   small1"><strong>مصرف دوره
                                                (لیتر)</strong></td>
                                            <td className="no-border   small1"><strong>{branchInfo.total_consumption}</strong></td>
                                        </tr>
                                        <tr>
                                            <td className="no-border   small1"><strong>میانگین مصرف
                                                (لیتر)</strong></td>
                                            <td className="no-border   small1"><strong>{branchInfo.average_consumption}</strong></td>
                                        </tr>
                                        <tr>
                                            <td className="no-border   small1"><strong>مصرف مازاد
                                                (لیتر)</strong></td>
                                            <td className="no-border   small1"><strong>{branchInfo.extra_consumption}</strong></td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className=" w-full mt-1 md:w-3/12 p-1">

                                <div className="table-responsive">
                                    <table className="table table-bordered">
                                        <thead className="bg-gray-200">
                                        <tr>
                                            <th colSpan={3} className="  "><strong>جدول روند
                                                مصرف</strong></th>
                                        </tr>
                                        </thead>
                                        <tbody className="table-hover">
                                        <tr>
                                            <td className=" text-center small1"><strong>دوره</strong></td>
                                            <td className="  small1"><strong>سال جاری</strong></td>
                                            <td className="  small1"><strong>سال قیل</strong></td>
                                        </tr>
                                        <tr>
                                            <td className="no-border text-center  small1"><strong>۱</strong></td>
                                            <td className="no-border   small1"><strong>{branchInfo.average_current_year_period1}</strong></td>
                                            <td className="no-border   small1"><strong>{branchInfo.average_last_year_period1}</strong></td>

                                        </tr>
                                        <tr>
                                            <td className="no-border text-center  small1"><strong>۲</strong></td>
                                            <td className="no-border   small1"><strong>{branchInfo.average_current_year_period2}</strong></td>
                                            <td className="no-border   small1"><strong>{branchInfo.average_last_year_period2}</strong></td>
                                        </tr>
                                        <tr>
                                            <td className="no-border text-center  small1"><strong>۳</strong></td>
                                            <td className="no-border   small1"><strong>{branchInfo.average_current_year_period3}</strong></td>
                                            <td className="no-border   small1"><strong>{branchInfo.average_last_year_period3}</strong></td>
                                        </tr>
                                        <tr>
                                            <td className="no-border text-center  small1"><strong>۴</strong></td>
                                            <td className="no-border   small1"><strong>{branchInfo.average_current_year_period4}</strong></td>
                                            <td className="no-border   small1"><strong>{branchInfo.average_last_year_period4}</strong></td>
                                        </tr>
                                        <tr>
                                            <td className="no-border  text-center small1"><strong>۵</strong></td>
                                            <td className="no-border   small1"><strong>{branchInfo.average_current_year_period5}</strong></td>
                                            <td className="no-border   small1"><strong>{branchInfo.average_last_year_period5}</strong></td>
                                        </tr>
                                        <tr>
                                            <td className="no-border  text-center small1"><strong>۶</strong></td>
                                            <td className="no-border   small1"><strong>{branchInfo.average_current_year_period6}</strong></td>
                                            <td className="no-border   small1"><strong>{branchInfo.average_last_year_period6}</strong></td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-bordered">
                                        <thead className="bg-gray-200">
                                        <tr>
                                            <th className="  "><strong>مهلت پرداخت</strong></th>
                                        </tr>
                                        </thead>
                                        <tbody className="table-hover">
                                        <tr>
                                            <td className="  small1"><strong>{branchInfo.payment_dead_line}</strong></td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="w-4/12 p-1">
                    <div className="w-full    ">
                        <div className="table-responsive">
                            <table className="table table-bordered">
                                <thead className="bg-gray-200">
                                <tr>
                                    <th className="  "><strong>عنوان هزینه</strong></th>
                                    <th className="  "><strong>مبلغ (ریال)</strong></th>
                                </tr>
                                </thead>
                                <tbody className="table-hover">
                                <tr>
                                    <td className="no-border   small1"><strong>بهای آب مصرفی</strong></td>
                                    <td className="no-border   small1"><strong>{branchInfo.water_price}</strong></td>
                                </tr>
                                <tr>
                                    <td className="no-border   small1"><strong>بهای خدمات دفع
                                        فاضلاب</strong></td>
                                    <td className="no-border   small1"><strong>{branchInfo.waste_water_price}</strong></td>
                                </tr>
                                <tr>
                                    <td className="no-border   small1"><strong>مالیات بر ارزش
                                        افزوده</strong></td>
                                    <td className="no-border   small1"><strong>{branchInfo.tax}</strong></td>
                                </tr>
                                <tr>
                                    <td className="no-border   small1"><strong>قانون بودجه + عوارض صنعت </strong>
                                    </td>
                                    <td className="no-border   small1"><strong>{branchInfo.village_abfa_portion}</strong></td>
                                </tr>
                                <tr>
                                    <td className="no-border   small1"><strong>&nbsp;</strong></td>
                                    <td className="no-border   small1"><strong>&nbsp;</strong></td>
                                </tr>
                                <tr>
                                    <td className="no-border   small1"><strong>جمع صورتحساب</strong></td>
                                    <td className="no-border   small1"><strong>{branchInfo.total_fee}</strong></td>
                                </tr>
                                <tr>
                                    <td className="no-border   small1"><strong>بدهی قبلی</strong></td>
                                    <td className="no-border   small1"><strong>{branchInfo.previous_debt}</strong></td>
                                </tr>
                                <tr>
                                    <td className="no-border   small1"><strong>کسر هزار ریال</strong></td>
                                    <td className="no-border   small1"><strong>{branchInfo.deduction_amount_1000_rial}</strong></td>
                                </tr>
                                <tr>
                                    <td className=" bg-gray-200 "><strong>مبلغ قابل پرداخت</strong></td>
                                    <td className="  small1"><strong>{branchInfo.amount}</strong></td>
                                </tr>
                                <tr>
                                    <td className="bg-gray-200"><strong>شناسه قبض</strong></td>
                                    <td className="  small1"><strong>{branchInfo.bill_id}</strong></td>
                                </tr>
                                <tr>
                                    <td className="bg-gray-200"><strong>شناسه پرداخت</strong></td>
                                    <td className="  small1"><strong>{branchInfo.pay_id}</strong></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="w-full p-1">
                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead className="border ">
                            <tr>
                                <th colSpan={1} className=" w-3/12 bg-gray-200 small1" ><strong>مبلغ به حروف</strong>
                                </th>
                                <th colSpan={4} className="  small1"><strong>{branchInfo.amount_in_word}</strong></th>
                            </tr>
                            </thead>
                            <tbody className="table-hover w-10/12">
                            <tr>
                                <td colSpan={2} className="no-border w-3/12    small1" >
                                    <strong>پیام : {branchInfo.debt_message} </strong></td>

                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="w-full flex flex-wrap justify-start p-1">
                    <div className="w-full md:w-8/12 p-1">
                        <strong className=" text-red-600" >* جهت پرداخت قبض آب بهاء و آگاهی
                            از آخرین بدهی از طریق تلفن ثابت با سامانه 1522 تماس حاصل فرمایید.</strong>
                    </div>
                    <div className="w-full md:w-4/12 p-1">
                        <strong className=" text-red-600" >* مهلت پرداخت مشمول بدهی قبلی نمی
                            گردد.</strong>
                    </div>
                    <div className="w-full flex justify-center mt-2 ">
                        <Button size="large" id="print-button" type="primary"  onClick={()=>{

                            window.print();

                        }}>چاپ قبض</Button>
                    </div>
                </div>
            </div>
        </div>
    </Container>
}
export default Bill;